/*
 * @Author: luting
 * @Date: 2022-05-05 19:53:50
 * @lastEditors: luting
 * @LastEditTime: 2023-07-26 10:28:04
 */
import React, { forwardRef, useImperativeHandle, useEffect, useMemo, useState } from 'react';
import { useIntl } from 'react-intl';
import { FormComponentProps } from 'sup-ui/lib/form';
import { Input, Form, Row, Col, Checkbox, Spin, Tooltip } from 'sup-ui';
import { getRecipientApi } from 'root/services/notice';
import Icon from 'root/components/Icon';
import messages from './messages';
import { INoticeForm } from './types';
import styles from './index.less';
const NoticeForm = forwardRef<FormComponentProps, INoticeForm>((props, ref) => {
  const intl = useIntl();
  const { form, disable, spinStatus, testStatus, record, errorStatsu } = props;
  const { status = false, message = '' } = spinStatus;
  const { status: testStyle = false, message: testMessage = '', showTip } = testStatus;
  const { getFieldDecorator } = form;
  const [checked, setChecked] = useState(false);
  const [recipientOptions, setRecipientOptions] = useState<any[]>([]);
  useImperativeHandle(ref, () => {
    return {
      form,
    };
  });

  useEffect(() => {
    setChecked(record?.ssl === 1);
  }, [record]);
  useEffect(() => {
    getRecipientList({ page: 1, size: 1000 });
  }, []);

  useEffect(() => {
    if (errorStatsu) {
      // 当测试链接失败时,将四个item状态更改为错误
      form.setFields({
        alertMailAddress: { value: form.getFieldValue('alertMailAddress'), errors: [new Error('')] },
        alertMailPort: { value: form.getFieldValue('alertMailPort'), errors: [new Error('')] },
        alertMailSend: { value: form.getFieldValue('alertMailSend'), errors: [new Error('')] },
        mailPassword: { value: form.getFieldValue('mailPassword'), errors: [new Error('')] },
      });
    }
  }, [errorStatsu]);

  const renderTooltip = useMemo(() => {
    return <div>{intl.formatMessage(messages.emailTip)}</div>;
  }, []);

  // 获取收件人数据列表
  const getRecipientList = (params: { page: number; size: number }) => {
    getRecipientApi(params).then((res) => {
      const {
        data: { data },
      } = res;
      data?.forEach((item: any) => {
        item.label = item.alertMailSend;
        item.value = item.alertMailSend;
      });

      data.unshift({
        label: intl.formatMessage(messages.senderEmail),
        value: 'current',
      });

      setRecipientOptions(data);
    });
  };

  const getEmailLabel = () => {
    return (
      <Tooltip overlayClassName={styles.noticeTip} title={renderTooltip}>
        {intl.formatMessage(messages.senderEmail)}
        <Icon type="tip16" className={styles.tipIcon} />
      </Tooltip>
    );
  };

  const onChange = (e: any) => {
    setChecked(e.target.checked);
  };
  // 自定义服务器地址校验
  // const checkValue = async (rule: any, value: string, callback: () => void) => {
  //   if (!value) return callback();
  //   const flagIp = /^((25[0-5]|2[0-4]\d|((1\d{2})|([1-9]?\d)))\.){3}(25[0-5]|2[0-4]\d|((1\d{2})|([1-9]?\d)))$/;
  //   const flagName = /http[s]{0,1}:\/\/([\w.]+\/?)\S*/;
  //   if (flagIp.test(value) || flagName.test(value)) {
  //     return callback();
  //   } else {
  //     throw new Error(intl.formatMessage(messages.ipRules));
  //   }
  // };

  // 验证容量最大值
  const checkVolume = async (rule: any, value: string, callback: () => void) => {
    if (Number(value) > 2048) throw new Error(intl.formatMessage(messages.sendError));
    return callback();
  };
  return (
    <Spin tip={message} spinning={status}>
      <Form layout="vertical">
        <Row gutter={14}>
          <Col span={15}>
            <Form.Item label={intl.formatMessage(messages.ip)} colon={false}>
              {getFieldDecorator('alertMailAddress', {
                validateTrigger: ['onBlur'],
                initialValue: record?.alertMailAddress,
                rules: [
                  {
                    required: !disable,
                    message: intl.formatMessage(messages.placeholder) + intl.formatMessage(messages.ip),
                  },
                ],
              })(
                <Input
                  placeholder={intl.formatMessage(messages.placeholder) + intl.formatMessage(messages.ip)}
                  disabled={disable}
                  autoComplete="off"
                  maxLength="64"
                />,
              )}
            </Form.Item>
          </Col>
          <Col span={5}>
            <Form.Item label={intl.formatMessage(messages.port)} colon={false}>
              {getFieldDecorator('alertMailPort', {
                validateTrigger: ['onBlur'],
                initialValue: record?.alertMailPort,
                rules: [
                  {
                    required: !disable,
                    message: intl.formatMessage(messages.placeholder) + intl.formatMessage(messages.port),
                  },
                  {
                    pattern: new RegExp(/^(([0-9]|[1-9]\d{1,3}|[1-5]\d{4}|6[0-5]{2}[0-3][0-5]))$/),
                    message: intl.formatMessage(messages.portRules),
                  },
                ],
              })(
                <Input
                  placeholder={intl.formatMessage(messages.placeholder) + intl.formatMessage(messages.port)}
                  disabled={disable}
                  maxLength="64"
                />,
              )}
            </Form.Item>
          </Col>
          <Col span={4} className={styles.ssl}>
            <Form.Item label={' '}>
              {getFieldDecorator('ssl', { initialValue: record?.ssl })(
                <Checkbox onChange={onChange} checked={checked} disabled={disable}>
                  SSL
                </Checkbox>,
              )}
            </Form.Item>
          </Col>
        </Row>

        <Row>
          <Col span={24}>
            <Form.Item label={getEmailLabel()} colon={false}>
              {getFieldDecorator('alertMailSend', {
                initialValue: record?.alertMailSend,
                validateTrigger: ['onBlur'],
                rules: [
                  {
                    required: !disable,
                    message: intl.formatMessage(messages.placeholder) + intl.formatMessage(messages.senderEmail),
                  },
                  {
                    pattern: new RegExp(
                      /^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/,
                    ),
                    message: intl.formatMessage(messages.emailRules),
                  },
                ],
              })(
                <Input
                  placeholder={intl.formatMessage(messages.placeholder) + intl.formatMessage(messages.senderEmail)}
                  disabled={disable}
                  maxLength="64"
                />,
              )}
            </Form.Item>
          </Col>
        </Row>

        <Row>
          <Col span={24}>
            <Form.Item label={intl.formatMessage(messages.senderPassword)} colon={false}>
              {getFieldDecorator('mailPassword', {
                initialValue: record?.mailPassword,
                validateTrigger: ['onBlur'],
                rules: [
                  {
                    required: !disable,
                    message: intl.formatMessage(messages.placeholder) + intl.formatMessage(messages.senderPassword),
                  },
                ],
              })(
                <Input.Password
                  placeholder={intl.formatMessage(messages.placeholder) + intl.formatMessage(messages.senderPassword)}
                  disabled={disable}
                  visibilityToggle={false}
                  autoComplete="new-password"
                  maxLength="64"
                />,
              )}
            </Form.Item>
          </Col>
        </Row>

        <Row>
          <Col span={24}>
            <Form.Item label={intl.formatMessage(messages.sendTip)} colon={false}>
              {getFieldDecorator('mailFileLimit', {
                initialValue: record?.mailFileLimit,
                validateTrigger: ['onBlur'],
                rules: [
                  {
                    pattern: new RegExp(/^\d+$/),
                    message: intl.formatMessage(messages.tipRules),
                  },
                  {
                    validator: checkVolume,
                  },
                ],
              })(
                <Input
                  placeholder={intl.formatMessage(messages.placeholder) + intl.formatMessage(messages.size)}
                  disabled={disable}
                  maxLength="64"
                />,
              )}
            </Form.Item>
          </Col>
        </Row>

        {!disable && (
          <Row>
            <Col span={24}>
              <Form.Item label={intl.formatMessage(messages.recipientList)} colon={false}>
                {getFieldDecorator('mails', {
                  initialValue: ['current'],
                  validateTrigger: ['onChange'],
                  rules: [
                    {
                      required: true,
                      message: intl.formatMessage(messages.recipientNull),
                    },
                  ],
                })(
                  <Checkbox.Group
                    options={recipientOptions}
                    className={styles.checkboxGroup}
                    disabled={disable || recipientOptions.length === 1}
                  />,
                )}
              </Form.Item>
            </Col>
          </Row>
        )}

        {showTip && !disable && (
          <Row>
            <Col span={24}>
              <span className={testStyle ? styles.testLinkSuccess : styles.testLinkFail}>{testMessage}</span>
            </Col>
          </Row>
        )}
      </Form>
    </Spin>
  );
});

export default Form.create()(NoticeForm);
